import { useState, useEffect } from 'react'

// Shared state for the countdown to keep all instances in sync
let globalTimeLeft = 23 * 3600 + 59 * 60 + 44 // 23h 59m 44s in seconds
let listeners: Array<(time: number) => void> = []
let intervalId: ReturnType<typeof setInterval> | null = null

const startGlobalTimer = () => {
  if (!intervalId) {
    intervalId = setInterval(() => {
      if (globalTimeLeft > 0) {
        globalTimeLeft -= 1
        listeners.forEach((listener) => listener(globalTimeLeft))
      } else {
        if (intervalId) clearInterval(intervalId)
      }
    }, 1000)
  }
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.push(setTimeLeft)
    startGlobalTimer()

    return () => {
      listeners = listeners.filter((l) => l !== setTimeLeft)
    }
  }, [])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  }
}
